import React from 'react';

import {MODALS_ID} from '../Modals';
import {TCloseWhen, TCloseWhenHandler, THead, TOverlay} from './types';

export const isValidElement = (element: THead | TOverlay) => {
  if (Array.isArray(element)) {
    return element.every((item) => React.isValidElement(item));
  }

  return React.isValidElement(element);
};

export const makeValidElement = <TProps extends TAnyObject>(
  element: THead | TOverlay,
  props?: TProps,
) =>
  isValidElement(element) ? element : React.createElement(element as TAnyComponent<TProps>, props);

export const isLinkElement = (target: Node, overlayNode: Node) =>
  overlayNode.contains(target) && target.nodeName === 'A';

export const isSubmitElement = (target: Node) => (target as HTMLButtonElement).type === 'submit';

export const isCancelElement = (target: Node) => (target as HTMLButtonElement).name === 'cancel';

export const isModalElement = (target: Node) => {
  const modalsNode = document.getElementById(MODALS_ID);

  return !!modalsNode?.contains(target);
};

export const closeWhenMap: Record<TCloseWhen, TCloseWhenHandler> = {
  clickAny: () => true,
  clickOutsideDropdown: (target, headNode, overlayNode) =>
    !headNode?.firstChild?.contains(target) && !overlayNode?.contains(target),
  clickOutsideOverlay: (target, headNode, overlayNode) => !overlayNode?.contains(target),
  clickOutsideOverlayOrSubmit: (target, headNode, overlayNode) =>
    closeWhenMap.clickOutsideOverlay(target, headNode, overlayNode) ||
    (overlayNode.contains(target) && isSubmitElement(target)),
  clickOutsideOverlayOrSubmitOrCancel: (target, headNode, overlayNode) =>
    closeWhenMap.clickOutsideOverlayOrSubmit(target, headNode, overlayNode) ||
    (overlayNode.contains(target) && isCancelElement(target)),
};
